import { Routes } from '@angular/router';
import { PermissionsEnum } from '../../../../../permission.enum';
import { permissionGuard } from '../../../../../shared/core/guard/permission.guard';

export const loanDetailsRoutes: Routes = [
  {
    path: 'loan-schedule',
    canActivate: [permissionGuard(PermissionsEnum.LoanScheduleView)],
    loadComponent: () => import('./components/loan-schedules/loan-schedules.component').then((m) => m.LoanSchedulesComponent),
  },
  {
    path: 'loan-transactions',
    canActivate: [permissionGuard(PermissionsEnum.TransactionView)],
    loadComponent: () => import('./components/transactions/transactions.component').then((m) => m.TransactionsComponent),
  },
  {
    path: 'activities',
    loadComponent: () => import('./components/activities/activities.component').then((m) => m.ActivitiesComponent),
  },
  {
    path: 'repayment-instruments',
    loadComponent: () => import('./components/repayment-instruments/repayment-instruments.component').then((m) => m.RepaymentInstrumentsComponent),
  },
  {
    path: 'audit-logs',
    loadComponent: () => import('./components/audit-logs/audit-logs.component').then((m) => m.AuditLogsComponent),
  },
];
